// extracted by mini-css-extract-plugin
export default {"link":"styles_link__s8vq8","borderAnimation":"styles_borderAnimation__Ba2FF"};